"use client";

import React from "react";
import Image from "next/image";
import { motion, type Variants } from "framer-motion";

const technologies: { name: string; src: string }[] = [
  { name: "React",   src: "/logo/technologies/React_(web_framework)-Logo.wine.svg" },
  { name: "Node.js", src: "/logo/technologies/Node.js-Logo.wine.svg" },
  { name: "Python",  src: "/logo/technologies/Python_(programming_language)-Logo.wine.svg" },
  { name: "PHP",     src: "/logo/technologies/PHP-Logo.wine.svg" },
  { name: "Vue.js",  src: "/logo/technologies/Vue.js-Logo.wine.svg" },
  { name: "Rust",    src: "/logo/technologies/Rust_(programming_language)-Logo.wine.svg" },
  { name: "Go",      src: "/logo/technologies/Go_(programming_language)-Logo.wine.svg" },
  { name: "Java",    src: "/logo/technologies/Java_(programming_language)-Logo.wine.svg" },
  { name: "Kotlin",  src: "/logo/technologies/Kotlin_(programming_language)-Logo.wine.svg" },
  { name: "Swift",   src: "/logo/technologies/Swift_(programming_language)-Logo.wine.svg" },
];

const allTech = [...technologies, ...technologies];

const headingVariants: Variants = {
  hidden: { opacity: 0, y: 24 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export default function Technologies() {
  return (
    <section className="relative w-full overflow-hidden py-14">
      <div className="relative z-10 mx-auto max-w-6xl px-4 sm:px-8">
        <motion.div
          variants={headingVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mb-10 text-center"
        >
          <h2 className="text-2xl font-bold tracking-tight text-[var(--foreground)] sm:text-3xl">
            Technologies we{" "}
            <span className="text-[var(--accent)]">build with</span>
          </h2>
          <p className="mt-2 text-sm text-[var(--foreground)]/60 sm:text-base">
            The tools behind every fast, reliable product we ship.
          </p>
        </motion.div>

        <div className="relative overflow-hidden">
          <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-24 bg-gradient-to-r from-[var(--background)] to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-24 bg-gradient-to-l from-[var(--background)] to-transparent" />

          <div className="marquee-track flex items-center gap-12">
            {allTech.map((tech, i) => (
              <div
                key={`${tech.name}-${i}`}
                className="flex shrink-0 flex-col items-center gap-2"
              >
                <div className="flex h-16 w-24 items-center justify-center rounded-xl bg-white px-3 py-2 shadow-sm">
                  <Image
                    src={tech.src}
                    alt={tech.name}
                    width={80}
                    height={48}
                    className="h-10 w-auto object-contain"
                  />
                </div>
                <span className="text-xs font-medium text-[var(--foreground-muted)]">
                  {tech.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
